import { render, staticRenderFns } from "./ts_send_create_worker.vue?vue&type=template&id=b58dd86c"
import script from "./ts_send_create_worker.vue?vue&type=script&lang=js"
export * from "./ts_send_create_worker.vue?vue&type=script&lang=js"
import style0 from "./ts_send_create_worker.vue?vue&type=style&index=0&id=b58dd86c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports